import { createRoot } from "react-dom/client";
import {useState, useEffect, useRef} from "react";
import List from '@/react/libraries/ButtonList/List';
import Table from './components/Table';
import axios from "axios";


const Page = ({ payload }) => {

    const { dataClassFromServer, msid, countryId, stateId, org, scheduleType, logoPath, orgProfileUrl, userRole, countryList, header, schedule, types, url } = payload;

	const buildJurisdictionFromPayload = () => {
		const obj = {};
		if (countryId !== null) {
			obj.country =
				typeof countryId === "string"
					? JSON.parse(countryId).map(String)
					: countryId;
		}
		if (stateId !== null) {
			obj.state =
				typeof stateId === "string"
					? JSON.parse(stateId).map(String)
					: stateId;
		}
		return obj;
	};
	
	const [type,setType] = useState(types[0].value);
    const [headers, setHeaders] = useState([])
	const [list, setList] = useState(dataClassFromServer[0]);
	const [data, setData] = useState([]);
	const [jurisdictionObj, setJurisdictionObj] = useState(buildJurisdictionFromPayload);
	const [loading, setLoading] = useState(false);
	const typeDropdownRef = useRef(null);
	const dataTypeDropdownRef = useRef(null);
	const dataTypeDropdownInstanceRef = useRef(null);
	const jdDropdownRef = useRef(null);
	const [dataType, setDataType] = useState('');
	const [keyword, setKeyword] = useState('');
	const jurisdictionRef = useRef(jurisdictionObj);
	const initialJurisdictionRef = useRef(buildJurisdictionFromPayload());
	const isProgrammaticJurisdictionUpdateRef = useRef(false);
	const [searchedKeyword, setSearchedKeyword] = useState('');
	useEffect(()=> {
		if (typeDropdownRef.current) {
			// initialize dropdown
			const dropdown =  new MultiLayerDropdown(typeDropdownRef.current, {
				searchPlaceholder: 'Select Localisation',
				levels: [''],
				keys: ['localizations'],
				multiSelect: false,
			});

			(types.length < 2) ? typeDropdownRef.current.setAttribute('disabled', 'true') : '';

			typeDropdownRef.current.addEventListener('itemSelect', (e) => {
				setType(e.detail.value);
			})

			dropdown.initializeData(types);

			// select the first item
			dropdown.selectItems({
				'localizations': [types[0].value]
			});
		}

		if (jdDropdownRef.current) {
			const countryDropdown = new MultiLayerDropdown(jdDropdownRef.current, {
		        searchPlaceholder: "Jurisdictions",
		        levels: ["Countries", "States"],
		        keys: ["country", "state"],
		    });
			
	    	countryDropdown.initializeData(countryList);
			const initialSelect = {};
			if (jurisdictionObj.country?.length) {
				initialSelect.country = jurisdictionObj.country;
			}
			if (jurisdictionObj.state?.length) {
				initialSelect.state = jurisdictionObj.state;
			}
			if (Object.keys(initialSelect).length) {
				countryDropdown.selectItems(initialSelect);
			}

			jdDropdownRef.current.addEventListener('itemClick', () => {
				if (isProgrammaticJurisdictionUpdateRef.current) return;
				let selectedVal = countryDropdown.getValues();
				if (Object.keys(selectedVal).length > 0) {
					setJurisdictionObj(selectedVal);
				}
			});

			jdDropdownRef.current.addEventListener('itemDeselect', function () {
				if (isProgrammaticJurisdictionUpdateRef.current) return;
				let selectedVal = countryDropdown.getValues();
			
				if (Object.keys(selectedVal).length > 0) {
					jurisdictionRef.current = selectedVal;
					setJurisdictionObj(selectedVal);
				} else {
					// revert to last valid — which is now correctly the single last item, not the full original list
					countryDropdown.selectItems(jurisdictionRef.current);
					toast.error("You can't leave the jurisdiction empty.");
				}
			});
		}

	}, []);

    useEffect(() => {
		fetchData();
	}, [list]);

	const fetchData = (opts = {}) => {
		const effectiveList = opts.list ?? list;
		const effectiveDataType = opts.dataType !== undefined ? opts.dataType : dataType;
		const effectiveKeyword = opts.keyword !== undefined ? opts.keyword : keyword;
		const effectiveJurisdiction =
			opts.jurisdictionObj !== undefined ? opts.jurisdictionObj : jurisdictionObj;
		const effectiveType = opts.type !== undefined ? opts.type : type;

		setLoading(true);

		if (!dataTypeDropdownInstanceRef.current) {
			dataTypeDropdownInstanceRef.current = new MultiLayerDropdown(
				dataTypeDropdownRef.current,
				{
					searchPlaceholder: 'Search records',
					levels: [''],
					keys: ['data_type'],
					multiSelect: false,
				}
			);
			dataTypeDropdownRef.current.addEventListener('itemSelect', (e) => {
				setDataType(e.detail.value);
			});
		}
		const dataTypeListQuery = new URLSearchParams({
			msid: String(msid),
			primary_filter: effectiveList,
		}).toString();
		const fetchDataTypes = axios.get(
			`${API_URL}list/business-function/data-type?${dataTypeListQuery}`,
			{ headers: window.HEADER_OBJ }
		);
		fetchDataTypes.then(response => {
			dataTypeDropdownInstanceRef.current.initializeData(response.data);
			if (effectiveDataType) {
				dataTypeDropdownInstanceRef.current.selectItems({
					data_type: [effectiveDataType],
				});
			} else {
				dataTypeDropdownInstanceRef.current.clear();
			}
		}).catch(error => {
			console.error(error);
		});

    	const fetchHeaders = axios.get(`${url}?type=${effectiveType}&msid=${msid}`, {
		    headers: window.HEADER_OBJ
		});

    	const bfParams = new URLSearchParams({
			msid: String(msid),
			primary_filter: effectiveList,
			type: effectiveType,
		});
		if (effectiveJurisdiction.country?.length) {
			bfParams.set("country_id", effectiveJurisdiction.country.join(","));
		}
		if (effectiveJurisdiction.state?.length) {
			bfParams.set("state_id", effectiveJurisdiction.state.join(","));
		}
		if (effectiveKeyword) {
			bfParams.set("keyword", effectiveKeyword);
		}

		// All rows for data-type options. Second business-function call only when a data type filter is active.
		const fetchAllData = axios.get(
			`${API_URL}business-function?${bfParams.toString()}`,
			{ headers: window.HEADER_OBJ }
		);

		const filteredParams = new URLSearchParams(bfParams);
		if (effectiveDataType) {
			filteredParams.set("secondary_filter", effectiveDataType);
		}

		const fetchFilteredData = effectiveDataType
			? axios.get(`${API_URL}business-function?${filteredParams.toString()}`, {
					headers: window.HEADER_OBJ,
			  })
			: null;

		const requests = fetchFilteredData
			? [fetchHeaders, fetchAllData, fetchFilteredData]
			: [fetchHeaders, fetchAllData];

		Promise.all(requests)
		  .then((results) => {
			const headersRes = results[0];
			const allDataRes = results[1];
			const filteredRes = fetchFilteredData ? results[2] : allDataRes;

			setHeaders(headersRes.data);
			setData(filteredRes.data);
			setLoading(false);
		  })
		  .catch((err) => {
			console.error(err);
			setLoading(false);
		  });
	
	}

	const handleClear = () => {
		const resetList = dataClassFromServer[0];
		const resetJurisdiction = buildJurisdictionFromPayload();
		initialJurisdictionRef.current = resetJurisdiction;

		setList(resetList);
		setDataType('');
		setSearchedKeyword('');
		setKeyword('');
		setType(types[0].value);
		setJurisdictionObj(resetJurisdiction);
		jurisdictionRef.current = resetJurisdiction;

		dataTypeDropdownInstanceRef.current?.clear();
		typeDropdownRef.current.__multi_layer_instance.selectItems({
			localizations: [types[0].value]
		});

		isProgrammaticJurisdictionUpdateRef.current = true;
		jdDropdownRef.current.__multi_layer_instance.clear();
		if (Object.keys(resetJurisdiction).length > 0) {
			jdDropdownRef.current.__multi_layer_instance.selectItems(resetJurisdiction);
		}
		queueMicrotask(() => {
			isProgrammaticJurisdictionUpdateRef.current = false;
		});

		fetchData({
			list: resetList,
			dataType: '',
			keyword: '',
			jurisdictionObj: resetJurisdiction,
			type: types[0].value,
		});
	};

	const handleClick =(name)=>{
		setList(name);
		setDataType('');
		setKeyword('');
		dataTypeDropdownInstanceRef.current.clear();
	};

	const keywordChange = (e) => {
		setKeyword(e.target.value);
	};

	const handleSearch = () => {
		fetchData();
		setSearchedKeyword(keyword);
	};

	return (
		<div className="flex flex-col gap-5">
			<div className="flex flex-col gap-0.5">
				<div className="flex gap-1 items-center page-title text-sub2 whitespace-nowrap">
					<h2>{list}</h2>
					<span className="w-3 h-0.5 bg-black rounded-primary"></span>
					<span>Retention schedule</span>
				</div>
				<p className="text-grey-text text-article mb-1.5">Select a business area to view applicable retention periods.</p>
				<div className={`flex gap-3 max-w-[900px] ${loading ? "cursor-wait pointer-events-none" : ""}`}>
					<div>
						<div id="countries" className="max-w-[400px]" ref={jdDropdownRef}></div>
					</div>
					<div>
						<div className="" ref={typeDropdownRef}></div>
					</div>
					<div>
						<div className="w-full rounded-primary" data-multi-select="false" ref={dataTypeDropdownRef}></div>
					</div>
					<input className="input-field" placeholder="Enter keyword" type="input" name="keyword" value={keyword} onChange={keywordChange} />
					<button className='btn h-max px-5' onClick={handleSearch}><span className="material-symbols-rounded">search</span></button>
					<button className='btn h-max px-5 btn-outline-primary' onClick={handleClear}><span className="material-symbols-rounded">cached</span></button>
				</div>
			</div>
			{/*<div className="w-full bg-white rounded-primary" data-multi-select="false" ref={dataTypeDropdownRef}></div>*/}
			<div className="flex gap-5 mx-2 xl:mx-0">
				<div className="page-card p-5 max-w-[340px]">
					{
	                    (org.publish_ms_settings !== null) &&  org.publish_ms_settings.display_logo_on_bf ?
						<div>
							<img className="max-h-[100px] h-full" src={logoPath} />
							<hr className="mt-4"/>
						</div> : (userRole === "Company Admin" ? <div>
								<p className="text-label">No logo found, please upload your logo and enable display logo from your <a className="text-primary hover:underline" href={orgProfileUrl}>Company profile</a></p>
								<hr className="mt-4"/>
							</div>
							: "")
					}

					<h2 className="text-sub2 font-medium mb-4 relative before:absolute before:w-24 before:h-1 leading-7 before:bg-primary before:rounded-primary before:-bottom-3">Business function</h2>
				 	<div className={`${loading ? "cursor-wait pointer-events-none sticky top-4 max-h-[90vh] overflow-hidden" : "sticky top-4 max-h-[90vh] overflow-hidden"}`}>
				 		<List name={list} onButtonClick={handleClick} data={dataClassFromServer}/>
				 	</div>
				</div>
				<div className="page-card p-4 gap-2.5 pb-8 min-w-min w-full">
			        <div className="fk-table-alt">
						<Table data={data} isLoading={loading} keyword={searchedKeyword} headers={headers} list={list}/>
			        </div>
					{!loading && <p className="text-primary text-article">This schedule is provided for guidance. If unsure, contact your compliance team.</p>}
				</div>
			</div>
		</div>
	)
}


const formatMonthYear = (dateStr) => {
	if (!dateStr) return "";
  
	const date = new Date(dateStr.replace(" ", "T"));
  
	return date.toLocaleString("en-US", {
	  month: "long",
	  year: "numeric",
	});
};

function initPage(selector, payload) {
	createRoot(document.querySelector(selector)).render(
		<Page payload={payload} />
	);
}

export default initPage;
